/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetAllPouchStatusResponseResponse,
  NoContentResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get all Pouch status list
 * @summary Get all Pouch status list
 */
export const getAllPouchStatus = (signal?: AbortSignal) => {
  return customInstance<GetAllPouchStatusResponseResponse | NoContentResponse>({
    url: `/bm-pouch-management/v1/pouch/status-list`,
    method: 'get',
    signal,
  });
};

export const getGetAllPouchStatusQueryKey = () => {
  return [`/bm-pouch-management/v1/pouch/status-list`] as const;
};

export const getGetAllPouchStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllPouchStatus>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPouchStatus>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllPouchStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllPouchStatus>>> = ({ signal }) =>
    getAllPouchStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllPouchStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllPouchStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllPouchStatus>>
>;
export type GetAllPouchStatusQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Get all Pouch status list
 */
export const useGetAllPouchStatus = <
  TData = Awaited<ReturnType<typeof getAllPouchStatus>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPouchStatus>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAllPouchStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
